/* eslint-disable */
import firebase from "firebase/app";
//import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
var db = firebase.firestore();
var batch = db.batch();
// const fbStorage = getStorage();

var smartFormRef = db.collection('agreements')
export default {
    add: function (formObj) {
        return smartFormRef.add(
            formObj
        ).then((docRef) => {
            return docRef.id;
        });
    },
    delete: function (formObj) {
        let form_uid = formObj.form_uid // get contact_uid (aka doc id)
        return smartFormRef.doc(form_uid).delete().then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
    },
    update: function (formObj) {
        let form_uid = formObj.form_uid // get contact_uid (aka doc id)
        // To update ag and favorite color:
        return smartFormRef.doc(form_uid).set(formObj)
            .then(() => {
                console.log("Document successfully updated!");
                return "Contact successfully updated!"
            });
    },
    getAll: function () {
        return smartFormRef.get()
            .then((querySnapshot) => {
                let _forms = []
                querySnapshot.forEach((doc) => {
                    let formObj = doc.data();
                    formObj["form_uid"] = doc.id; // store doc.id as form_uid
                    _forms.push(formObj); // push to temp array
                    //console.log(doc.id, " => ", doc.data());
                });
                return _forms; // returns array of forms
            })
            .catch((error) => {
                console.log("SmartForms: getAll() error: ", error);
            })
    },
    batchUpdate: function (arrayOfForms, updateObject) {

        if (typeof arrayOfForms != Array) { // checks to make sure array is is provided
            console.log('SmartForms batchUpdate not an array')
            return; // stop batch update
        }

        arrayOfForms.forEach(formObj => {
            let form_uid = formObj.form_uid // get form_uid (aka doc id)
            batch.update(smartFormRef.doc(form_uid), updateObject);
        })

        return batch.commit().then(() => {
            return "SmartForm: Batch Update Successful"
        });
    },
    // #region UPLOAD TO STORAGE BUCKET
    // upload(item) {

    // }

    // #endregion
}